import React from 'react';
import { Quote, Star } from 'lucide-react';
// Simple SVG icon for Google
const GoogleIcon = () => <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor" data-id="element-470">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" data-id="element-471" />
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" data-id="element-472" />
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" data-id="element-473" />
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" data-id="element-474" />
  </svg>;
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Therapy with Esther has been life-changing. She provided a safe space where I finally felt heard and understood. Her compassionate approach helped me navigate a very difficult transition.',
    initials: 'M. T.',
    type: 'Individual Therapy'
  }, {
    quote: 'We were struggling to communicate and on the verge of separation. The tools and insights we gained through couples counselling helped us rebuild our foundation and reconnect.',
    initials: 'J. & S.',
    type: 'Couples Counselling'
  }, {
    quote: "I've struggled with anxiety for years. Esther helped me uncover the root causes and gave me practical, effective strategies to manage my symptoms. I feel like I have my life back.",
    initials: 'A. R.',
    type: 'Anxiety Support'
  }];
  return <section id="testimonials" className="py-12 lg:py-16 bg-olive" data-id="element-475">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-476">
        <div className="text-center max-w-xl mx-auto mb-10" data-id="element-477">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white mb-3" data-id="element-478">
            What Clients Say
          </h2>
          <p className="text-white/70 text-base font-medium" data-id="element-479">
            Reflections from individuals and couples who have engaged in the
            therapeutic process.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12" data-id="element-480">
          {testimonials.map((t, index) => <div key={index} data-id="element-481">
              <div className="bg-white/10 border border-white/10 rounded-xl p-6 h-full flex flex-col relative" data-id="element-482">
                <Quote className="absolute top-4 right-4 text-white/10 w-8 h-8 rotate-180" data-id="element-483" />
                <div className="flex gap-0.5 mb-4" data-id="element-484">
                  {[...Array(5)].map((_, i) => <Star key={i} size={14} className="fill-gold text-gold" data-id="element-485" />)}
                </div>
                <p className="text-white/85 italic mb-6 flex-grow text-base leading-relaxed font-medium" data-id="element-486">
                  "{t.quote}"
                </p>
                <div className="mt-auto pt-4 border-t border-white/10 flex items-center justify-between" data-id="element-487">
                  <span className="font-bold text-white text-base" data-id="element-488">
                    {t.initials}
                  </span>
                  <span className="text-xs text-gold font-bold uppercase tracking-wide" data-id="element-489">
                    {t.type}
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        {/* Google Review CTA */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 text-center max-w-3xl mx-auto mb-8" data-id="element-490">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-white mb-3" data-id="element-491">
            Had a positive experience? We'd love to hear from you!
          </h3>
          <p className="text-white/70 text-base font-medium mb-6" data-id="element-492">
            Your review helps others find the support they need on their healing
            journey.
          </p>
          <a href="https://share.google/icvD2yMNf6yhvy7Im" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-gold hover:bg-gold/90 text-white px-8 py-3.5 rounded-full font-bold text-base transition-all shadow-lg" data-id="element-493">
            <GoogleIcon data-id="element-494" />
            <span className="ml-2" data-id="element-495">Leave a Google Review</span>
          </a>
        </div>

        <div className="text-center" data-id="element-496">
          <p className="text-xs text-white/40 italic font-medium" data-id="element-497">
            * Names and identifying details have been changed to protect client
            privacy.
          </p>
        </div>
      </div>
    </section>;
}